export function getCookie(name: string): string | null {
	const prefix = name + '=';
	const cookies = document.cookie.split('; ');
	for (const cookie of cookies) {
		if (cookie.startsWith(prefix)) {
			return decodeURIComponent(cookie.substring(prefix.length));
		}
	}
	return null;
}

export function setCookie(name: string, value: string, days: number): void {
	const expires = new Date(Date.now() + days * 864e5).toUTCString();
	document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
}

export function isDismissed(cookieName: string): boolean {
	return getCookie(cookieName) === '1';
}

export function setDismissed(cookieName: string, days: number): void {
	setCookie(cookieName, '1', days);
}
